<template>
  <div></div>
</template>

<script>
import serviceRegistery from '../../mixins/serviceRegistery'
export default {
  created: function() {
    this.loadResources()
  },
  methods: {
    loadResources() {
      let self = this
      let p1 = new Promise(function(resolve) {
        // Get Create Channel Meta data.
        serviceRegistery
          .makeCall({
            url:
              self.$hostnameStatic +
              'static/assets/data/channel_config_form.json',
            method: 'GET'
          })
          .then(
            response => {
              self.$store.state.channelStore.channelFormData = JSON.parse(
                JSON.stringify(response.data)
              )
              self.$store.state.channelStore.orgChannelFormData = JSON.parse(
                JSON.stringify(response.data)
              )
              console.log(self.$store.state.channelStore.channelFormData)
              resolve(response.data)
            },
            error => {
              console.log('Error in getting static JSON file data', error)
            }
          )
      })
      let p2 = new Promise(function(resolve) {
        // Get Channel List.
        serviceRegistery
          .makeCall({
            url: self.$hostname + 'services/channel/all',
            method: 'POST'
          })
          .then(
            response => {
              self.$store.state.channelStore.channelListData = JSON.parse(
                JSON.stringify(response.data)
              )
              console.log(self.$store.state.channelStore.channelListData)
              resolve(response.data)
            },
            error => {
              console.log('Error in getting static JSON file data', error)
            }
          )
      })

      Promise.all([p1, p2]).then(values => {
        this.loadApp()
      })
    },
    loadApp() {
      this.$router.push('/channel/channelList')
    }
  }
}
</script>

<style>
</style>